import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';

// Custom components
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { IoMdAdd } from 'react-icons/io';
import ReactPaginate from 'react-paginate';
import AppoinmentModel from './AppoinmentModel';
import AppoinmentView from './AppoinmentView';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { allProblemDetail, appointementGet, appointementGetById, countAppointment, searchAppointmentDetail } from '../../../redux/actions/Files.action';
import { IoSearchOutline } from 'react-icons/io5';
import Select from 'react-select';
import { RiRestartLine } from 'react-icons/ri';

const Index = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [feedbackId, setFeedbackId] = useState()
  const [mainPage, setMainPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchDefault, setSearchDefault] = useState({
    page: '',
    search: '',
  });
  const limits = {
    page: mainPage,
    limit: rowsPerPage,
  };
  const appointement = useSelector((state) => state.files)
  console.log('appointement', appointement);

  const [currentDate, setCurrentDate] = useState('');
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState('');

  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];

    setCurrentDate(formattedDate);
  }, []);

  const toggle = () => {
    setShow(!show);
  };

  const viewToggle = () => {
    setViewModal(!viewModal);
  };

  const handleAppointment = (id) => {
    dispatch(appointementGetById(id))
  }

  useEffect(() => {
    if (location.state?.showModal) {
      setShow(true);
    }
  }, [location.state]);

  const data = {
    date: currentDate
  }

  const getStatusColor = (status) => {
    if (status === 'confirm') {
      return '#E9FEF5';
    } else if (status === 'pending') {
      return '#ffffcc';
    }
  };

  const handleSearch = (e) => {
    const newSearchQuery = e.target.value;
    setSearchQuery(newSearchQuery);
    const newSearchParams = {
      ...searchDefault,
      search: newSearchQuery || '',
      page: 1,
      limit: rowsPerPage,
      date: currentDate
    };
    setSearchDefault(newSearchParams);
    setMainPage(1);
    const queryParams = new URLSearchParams(newSearchParams).toString();
    dispatch(searchAppointmentDetail(queryParams, selectedOption?.value || ""));
  };

  const ChangeMainPage = (selected) => {
    setMainPage(parseInt(selected.selected) + 1);
  };

  const handleRowsPerPageChange = (e) => {
    const newRowsPerPage = parseInt(e.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setMainPage(1);
  };

  const postPerPage = rowsPerPage;
  const PageCount = Math.ceil(
    appointement?.getAppointment?.data?.totalCount / postPerPage,
  );

  useEffect(() => {
    if (currentDate) {
      const data = {
        date: currentDate
      };

      dispatch(appointementGet(currentDate, limits));
      dispatch(countAppointment(data));
      dispatch(allProblemDetail())
    }
  }, [mainPage, currentDate, rowsPerPage]);

  useEffect(() => {
    if (appointement?.allProblem?.data?.Problem) {
      const formattedOptions = appointement.allProblem.data.Problem.map((problem) => ({
        value: problem.problem,
        label: problem.problem
      }));
      setOptions(formattedOptions);
      console.log('formattedOptions', formattedOptions);

    }
  }, [appointement]);

  useEffect(() => {
    const newSearchParams = {
      ...searchDefault,
      search: searchQuery || '',
      page: 1,
      limit: rowsPerPage,
      date: currentDate
    };
    setSearchDefault(newSearchParams);
    setMainPage(1);
    const queryParams = new URLSearchParams(newSearchParams).toString();

    if (selectedOption) {
      dispatch(searchAppointmentDetail(queryParams, selectedOption?.value || ""));
    }
  }, [selectedOption])

  const handleReset = () => {
    setSelectedOption('')
    dispatch(appointementGet(currentDate, limits));
  }

  return (
    <>
      <div className="mt-[100px] d-flex justify-content-between">
        <div>
          <label className="text-sm block mb-1">Consult</label>
          <div className='flex items-center gap-2'>
            <Select className='w-[250px] me-auto focus:!outline-none'
              value={selectedOption}
              onChange={setSelectedOption}
              options={options}
            />
            <RiRestartLine size={20} className='cursor-pointer' onClick={handleReset} />
          </div>
        </div>
        <div className='flex items-center gap-3'>
          <div className='flex item-center'>
            <div className='flex gap-2 !text-gray-600 px-3  border-r-2 !border-[gray]'>
              <h5>Total :</h5>
              <h5 className='border-b-2 !border-[gray] '>{appointement?.countAppointment?.data?.Total}</h5>
            </div>
            <div className='flex gap-2 px-3 text-success border-r-2 !border-[gray]'>
              <h5 className=''>Confirm :</h5>
              <h5 className='border-b-2  !border-[gray] '>{appointement?.countAppointment?.data?.Confirmed}</h5>
            </div>
            <div className='flex gap-2 text-warning px-3 '>
              <h5>Pending :</h5>
              <h5 className='border-b-2 !border-[gray] '>{appointement?.countAppointment?.data?.Pending}</h5>
            </div>
          </div>
          <div>
            <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2 me-2">
              <IoSearchOutline />
              <input
                type="text"
                name="search"
                value={searchQuery}
                onChange={handleSearch}
                className="w-full outline-none"
                placeholder="Search..."
              />
            </div>
          </div>
          <Button
            onClick={toggle}
            className="!bg-theme-dark fw-bold d-flex align-item-center border-0"
          >
            <IoMdAdd className="mt-1 gap-1" />
            Add Appointment
          </Button>
        </div>
      </div>

      <div className='flex items-center mt-5'>
        <div className='ms-auto border-r pe-3 me-3'>Total Records: <span className='text-success border-b border-success'>{appointement?.getAppointment?.data?.totalCount || 0}</span></div>
        <div className='flex justify-end'>
          Rows per page:
          <select
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
            className="ms-2 border rounded-md focus:outline-none"
          >
            <option value={10}>10</option>
            <option value={30}>30</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={500}>500</option>
          </select>
        </div>
      </div>
      <div className="mt-[50px] mb-3">
        <TableContainer>
          <Table
            className='!border-2'
            cellPadding="10"
            style={{ width: "100%", textAlign: "left", borderCollapse: "collapse" }}
          >
            <Thead className='!border-2 !border-[#e5e7eb]'>
              <Tr>
                <Th style={{ width: '100px' }} className='!border-r-2 !border-[#e5e7eb]'>Time</Th>
                <Th colSpan={6} className='text-center'>
                  <input type='date' value={currentDate} className='border-0 outline-none' onChange={(e) => setCurrentDate(e.target.value)} />
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {
                appointement?.getAppointment?.data?.appointmentData
                  ?.sort((a, b) => {
                    const convertTo24Hour = (time) => {
                      const [hourMinute, meridiem] = time.split(" ");
                      let [hour, minute] = hourMinute.split(":").map(Number);
                      if (meridiem === "PM" && hour !== 12) hour += 12;
                      if (meridiem === "AM" && hour === 12) hour = 0;
                      return hour * 60 + minute;
                    };

                    const timeA = convertTo24Hour(a._id.time);
                    const timeB = convertTo24Hour(b._id.time);

                    return timeA - timeB; 
                  })
                  .map((res, index) => {
                    return (
                      <Tr key={index}>
                        <Td style={{ backgroundColor: "#f0f0f0", padding: "10px" }} className='!border-[#b3b4b5]'>
                          {res?._id?.time}
                        </Td>

                        {
                          res?.appointments?.map((appointment) => {
                            return (
                              <Td
                                key={appointment._id}
                                onClick={() => {
                                  viewToggle();
                                  handleAppointment(appointment._id);
                                  setFeedbackId(appointment.patientId);
                                }}
                                style={{
                                  backgroundColor: getStatusColor(appointment.status),
                                  padding: "10px",
                                  cursor: "pointer",
                                  margin: "5px",
                                  border: "1px solid #ccc",
                                  textAlign: "center",
                                }}
                              >
                                <span className='capitalize'>
                                  {appointment.firstName} {appointment.lastName}
                                </span> ({appointment.phoneNumber}) - {appointment.issue} - ({appointment.billingLabel})
                              </Td>
                            );
                          })
                        }
                      </Tr>
                    );
                  })
              }
            </Tbody>
          </Table>
        </TableContainer>
      </div >

      <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={ChangeMainPage}
        pageRangeDisplayed={5}
        pageCount={PageCount}
        forcePage={mainPage - 1}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
        className="pagination"
      />

      <AppoinmentModel show={show} toggle={toggle} currentDate={currentDate} />
      <AppoinmentView viewModal={viewModal} setViewModal={setViewModal} viewToggle={viewToggle} currentDate={currentDate} data={data} limits={limits} feedbackId={feedbackId} />
    </>
  );
};

export default Index;
